/**
 * answer-edit-photos.js
 */

import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import FilesEdit from 'components/files/edit';


export default function AnswerEditPhotos(props) {
  const {
    drawerState,
    translation,
    formPrefix = '',
  } = props;
  const { control } = useFormContext();
  const wasPerformedValue = useWatch({ control, name: `${formPrefix}wasExercisePerformed` });

  return (
    <>
      {wasPerformedValue &&
       <FilesEdit 
        name={`${formPrefix}files`}
        drawerState={drawerState}
        translation={translation}
       />}
    </>
  );
}